import { squarePlus } from "@/components/icons/SVGIcons";
import { Tooltip } from "react-tooltip";
import { cubeCustomColors } from "../../../../tailwind.config";
import SVGandTextContainer from "./SVGandTextContainer";
import ToolTipMappedSVGandButton from "./ToolTipMappedSVGandButton";
import { baseWidgetDetails } from "@/lib/widgetsLayoutDir";
import { onAddWidget } from "@/lib/widgetHelperFunctions";
import workspacesTabsStore from "@/store/workspacesTabsStore";

const AddWidgetButton = ({
  toolbarOpen,
  theme,
}: {
  toolbarOpen: boolean;
  theme: string | undefined;
}) => {
  const cubeBase700 = cubeCustomColors.cubeBase[700];
  const cubeBaseDark700 = cubeCustomColors.cubeBaseDark[700];

  //Change the widgets the user is able to see based on the front end directory.
  // Step 2 - Filter the dic based on what are options in the current ENV.
  const widgetsAvailable = workspacesTabsStore(
    (state) => state.widgetsAvailable,
  );
  // Filtered state of the button options:
  const currentWidgetOptions = baseWidgetDetails.filter((widgetDetail) =>
    widgetsAvailable.includes(widgetDetail.component),
  );

  return (
    <>
      <div className={" w-full dark:text-white"}>
        <SVGandTextContainer
          tooltipID={"widgets"}
          SVGIcon={squarePlus}
          toolbarOpen={toolbarOpen}
          openText={"Add Widget"}
        />
      </div>
      <Tooltip
        id={"widgets"}
        place="right-start"
        variant="info"
        className="z-20"
        clickable={true}
        // openOnClick={true}
        opacity={1}
        style={{
          backgroundColor: theme == "dark" ? cubeBaseDark700 : cubeBase700,
          margin: "0px",
          padding: "2px",
          paddingLeft: "5px",
          paddingRight: "5px",
        }}
        offset={toolbarOpen ? 40 : 20}
        border="1px solid gray"
      >
        <div id="addWidget" className="w-full pb-1">
          <div className="flex w-full flex-col gap-1">
            {currentWidgetOptions.length > 0 ? (
              currentWidgetOptions.map((button) => (
                <ToolTipMappedSVGandButton
                  button={button}
                  onClickAction={(button: any) => {
                    onAddWidget(button);
                  }}
                  dataTestID="addWidget"
                  key={button.displayName}
                />
              ))
            ) : (
              <div
                data-testid="widgetLoading"
                className="flex items-center px-2 py-1"
              >
                Loading Widgets
              </div>
            )}
          </div>
        </div>
      </Tooltip>
    </>
  );
};

export default AddWidgetButton;
